import { rewriteLocalMediaUrl } from '../constants/config';

const FLAG_CDN = 'https://flagcdn.com/w40';

const FLAG_NAME_TO_CODE = {
  russia: 'ru',
  'russian federation': 'ru',
  россия: 'ru',
  'российская федерация': 'ru',
  'european union': 'eu',
  'european-union': 'eu',
  europe: 'eu',
  eu: 'eu',
  евросоюз: 'eu',
  'европейский союз': 'eu',
  'united states': 'us',
  'united states of america': 'us',
  usa: 'us',
  america: 'us',
  'united kingdom': 'gb',
  uk: 'gb',
  'great britain': 'gb',
  britain: 'gb',
  england: 'gb-eng',
  scotland: 'gb-sct',
  wales: 'gb-wls',
  'northern ireland': 'gb-nir',
  'south korea': 'kr',
  korea: 'kr',
  'republic of korea': 'kr',
  'north korea': 'kp',
  'czech republic': 'cz',
  czechia: 'cz',
  'united arab emirates': 'ae',
  uae: 'ae',
  vietnam: 'vn',
  'viet nam': 'vn',
  moldova: 'md',
  'republic of moldova': 'md',
  'ivory coast': 'ci',
  "cote d'ivoire": 'ci',
  'côte d’ivoire': 'ci',
  tanzania: 'tz',
  bolivia: 'bo',
  venezuela: 've',
  iran: 'ir',
  syria: 'sy',
  laos: 'la',
  brunei: 'bn',
  taiwan: 'tw',
  palestine: 'ps',
  vatican: 'va',
  'vatican city': 'va',
  macau: 'mo',
  macao: 'mo',
  'hong kong': 'hk',
  'bosnia and herzegovina': 'ba',
  bosnia: 'ba',
  'north macedonia': 'mk',
  macedonia: 'mk',
  'cape verde': 'cv',
  'eswatini': 'sz',
  swaziland: 'sz',
  'east timor': 'tl',
  timor: 'tl',
  'democratic republic of the congo': 'cd',
  congo: 'cg',
  'republic of the congo': 'cg',
  belarus: 'by',
  беларусь: 'by',
  kazakhstan: 'kz',
  казахстан: 'kz',
  uzbekistan: 'uz',
  узбекистан: 'uz',
  kyrgyzstan: 'kg',
  киргизия: 'kg',
  кыргызстан: 'kg',
  tajikistan: 'tj',
  таджикистан: 'tj',
  turkmenistan: 'tm',
  туркменистан: 'tm',
  armenia: 'am',
  армения: 'am',
  georgia: 'ge',
  грузия: 'ge',
  azerbaijan: 'az',
  азербайджан: 'az',
  ukraine: 'ua',
  украина: 'ua',
  turkey: 'tr',
  türkiye: 'tr',
  germany: 'de',
  германия: 'de',
  france: 'fr',
  франция: 'fr',
  spain: 'es',
  испания: 'es',
  italy: 'it',
  италия: 'it',
  poland: 'pl',
  польша: 'pl',
  china: 'cn',
  китай: 'cn',
  japan: 'jp',
  япония: 'jp',
  brazil: 'br',
  бразилия: 'br',
  argentina: 'ar',
  аргентина: 'ar',
  netherlands: 'nl',
  holland: 'nl',
  portugal: 'pt',
  belgium: 'be',
  sweden: 'se',
  norway: 'no',
  finland: 'fi',
  denmark: 'dk',
  switzerland: 'ch',
  austria: 'at',
  greece: 'gr',
  serbia: 'rs',
  croatia: 'hr',
  slovenia: 'si',
  slovakia: 'sk',
  hungary: 'hu',
  romania: 'ro',
  bulgaria: 'bg',
  albania: 'al',
  montenegro: 'me',
  lithuania: 'lt',
  latvia: 'lv',
  estonia: 'ee',
  israel: 'il',
  india: 'in',
  canada: 'ca',
  mexico: 'mx',
  australia: 'au',
  'new zealand': 'nz',
  'south africa': 'za',
  nigeria: 'ng',
  egypt: 'eg',
  morocco: 'ma',
  tunisia: 'tn',
  algeria: 'dz',
  qatar: 'qa',
  'saudi arabia': 'sa',
  afghanistan: 'af',
  andorra: 'ad',
  angola: 'ao',
  'antigua and barbuda': 'ag',
  bahamas: 'bs',
  bahrain: 'bh',
  bangladesh: 'bd',
  barbados: 'bb',
  belize: 'bz',
  benin: 'bj',
  bhutan: 'bt',
  botswana: 'bw',
  'burkina faso': 'bf',
  burundi: 'bi',
  cambodia: 'kh',
  cameroon: 'cm',
  'central african republic': 'cf',
  chad: 'td',
  chile: 'cl',
  colombia: 'co',
  comoros: 'km',
  'costa rica': 'cr',
  cuba: 'cu',
  cyprus: 'cy',
  djibouti: 'dj',
  dominica: 'dm',
  'dominican republic': 'do',
  ecuador: 'ec',
  'el salvador': 'sv',
  'equatorial guinea': 'gq',
  eritrea: 'er',
  ethiopia: 'et',
  fiji: 'fj',
  gabon: 'ga',
  gambia: 'gm',
  ghana: 'gh',
  grenada: 'gd',
  guatemala: 'gt',
  guinea: 'gn',
  'guinea-bissau': 'gw',
  guyana: 'gy',
  haiti: 'ht',
  honduras: 'hn',
  iceland: 'is',
  indonesia: 'id',
  iraq: 'iq',
  ireland: 'ie',
  jamaica: 'jm',
  jordan: 'jo',
  kenya: 'ke',
  kiribati: 'ki',
  kuwait: 'kw',
  lebanon: 'lb',
  lesotho: 'ls',
  liberia: 'lr',
  libya: 'ly',
  liechtenstein: 'li',
  luxembourg: 'lu',
  madagascar: 'mg',
  malawi: 'mw',
  malaysia: 'my',
  maldives: 'mv',
  mali: 'ml',
  malta: 'mt',
  'marshall islands': 'mh',
  mauritania: 'mr',
  mauritius: 'mu',
  micronesia: 'fm',
  monaco: 'mc',
  mongolia: 'mn',
  mozambique: 'mz',
  myanmar: 'mm',
  namibia: 'na',
  nauru: 'nr',
  nepal: 'np',
  nicaragua: 'ni',
  niger: 'ne',
  oman: 'om',
  pakistan: 'pk',
  palau: 'pw',
  panama: 'pa',
  'papua new guinea': 'pg',
  paraguay: 'py',
  peru: 'pe',
  philippines: 'ph',
  rwanda: 'rw',
  'saint kitts and nevis': 'kn',
  'saint lucia': 'lc',
  'saint vincent and the grenadines': 'vc',
  samoa: 'ws',
  'san marino': 'sm',
  'sao tome and principe': 'st',
  senegal: 'sn',
  seychelles: 'sc',
  'sierra leone': 'sl',
  singapore: 'sg',
  'solomon islands': 'sb',
  somalia: 'so',
  'south sudan': 'ss',
  'sri lanka': 'lk',
  sudan: 'sd',
  suriname: 'sr',
  thailand: 'th',
  togo: 'tg',
  tonga: 'to',
  'trinidad and tobago': 'tt',
  tuvalu: 'tv',
  uganda: 'ug',
  uruguay: 'uy',
  vanuatu: 'vu',
  yemen: 'ye',
  zambia: 'zm',
  zimbabwe: 'zw',
};

const ISO_CODE_PATTERN = /^[a-z]{2}(?:-[a-z]{2,5})?$/;

const normalizeFlagKey = (value) => String(value || '')
  .trim()
  .toLowerCase()
  .replace(/[_-]+/g, ' ')
  .replace(/\s+/g, ' ');

export const getFlagCode = (value) => {
  if (!value || typeof value !== 'string') return '';
  const trimmed = value.trim();
  if (!trimmed || /^https?:\/\//i.test(trimmed) || trimmed.startsWith('data:') || trimmed.includes('/')) {
    return '';
  }

  const lower = trimmed.toLowerCase();
  if (ISO_CODE_PATTERN.test(lower)) return lower;

  const key = normalizeFlagKey(trimmed);
  if (FLAG_NAME_TO_CODE[key]) return FLAG_NAME_TO_CODE[key];
  return '';
};

export const getFlagUrl = (value) => {
  if (!value) return '';
  const trimmed = String(value).trim();
  if (!trimmed) return '';
  if (trimmed.startsWith('data:')) return trimmed;
  if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith('//')) return rewriteLocalMediaUrl(trimmed);

  const code = getFlagCode(trimmed);
  return code ? `${FLAG_CDN}/${code}.png` : '';
};

export const getCityFlagValue = (city) => (
  city?.flag || city?.city_flag || city?.country_flag || city?.country || ''
);

const SPECIAL_FLAG_NAMES = {
  eu: { ru: 'Европейский союз', en: 'European Union' },
  un: { ru: 'Организация Объединённых Наций', en: 'United Nations' },
  xk: { ru: 'Косово', en: 'Kosovo' },
  'gb-eng': { ru: 'Англия', en: 'England' },
  'gb-sct': { ru: 'Шотландия', en: 'Scotland' },
  'gb-wls': { ru: 'Уэльс', en: 'Wales' },
  'gb-nir': { ru: 'Северная Ирландия', en: 'Northern Ireland' },
};

const ISO_FLAG_CODES = `
ad ae af ag al am ao ar at au az ba bb bd be bf bg bh bi bj bn bo br bs bt bw by bz
ca cd cf cg ch ci cl cm cn co cr cu cv cy cz de dj dk dm do dz ec ee eg er es et fi
fj fm fr ga gb gd ge gh gm gn gq gr gt gw gy hk hn hr ht hu id ie il in iq ir is it
jm jo jp ke kg kh ki km kn kp kr kw kz la lb lc li lk lr ls lt lu lv ly ma mc md me
mg mh mk ml mm mn mo mr mt mu mv mw mx my mz na ne ng ni nl no np nr nz om pa pe pg
ph pk pl ps pt pw py qa ro rs ru rw sa sb sc sd se sg si sk sl sm sn so sr ss st sv
sy sz td tg th tj tl tm tn to tr tt tv tw tz ua ug us uy uz va vc ve vn vu ws ye
za zm zw
`.trim().split(/\s+/);

const extraFlagCodes = Object.keys(SPECIAL_FLAG_NAMES);

export const getFlagOptions = (lang = 'ru') => {
  const locale = lang === 'en' ? 'en' : 'ru';
  let display = null;
  try {
    display = new Intl.DisplayNames([locale], { type: 'region' });
  } catch (error) {
    display = null;
  }

  const options = [];
  const seen = new Set();

  const addOption = (code, name) => {
    const normalized = String(code || '').trim().toLowerCase();
    if (!normalized || seen.has(normalized) || !name) return;
    seen.add(normalized);
    options.push({ code: normalized, name });
  };

  extraFlagCodes.forEach((code) => {
    const names = SPECIAL_FLAG_NAMES[code] || {};
    addOption(code, names[locale] || names.ru || code);
  });

  ISO_FLAG_CODES.forEach((code) => {
    const upper = code.toUpperCase();
    const name = display ? display.of(upper) : upper;
    addOption(code, name || upper);
  });

  return options.sort((a, b) => a.name.localeCompare(b.name, locale));
};
